import {createSelector} from 'reselect';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings],
  settings => !!settings?.should_validate_address_delivery_option_mismatch,
);
